import { lazy } from "react";
import NotFound from "./NotFound";
import IndexOfLogin from "../login/IndexOfLogin";
import ListFLProjects from "../roles/project-admin/projects/fl/ListFLProjects";
import FLProjectCreation from "../roles/project-admin/projects/fl/FLProjectCreation";
import { LOCAL_IMAGE } from "../../images/ImageConstant";
import IndexOfManageClient from "../roles/project-admin/manage-client/IndexOfManageClient";
import UploadDataForm from "../roles/site-manger/upload-data/UploadDataForm";
import IndexOfML from "../roles/project-admin/projects/ml/IndexOfML";
import IndexOfEda from "../eda/IndexOfEda";
import MlTabs from "../roles/project-admin/projects/ml/ml-tab/MlTabs";
import ActivityLogs from "./../activity-logs/ActivityLogs";
import ChunkTest from "../test/ChunkTest";
import IndexOfNotification from "../notifications/IndexOfNotification";
const RoleSelection = lazy(() => import("../login/RoleSelection"));
const IndexOfProfile = lazy(() => import("../profile/IndexOfProfile"));
const IndexOfPlatformAdmin = lazy(() =>
  import("../roles/platform-admin/IndexOfPlatformAdmin")
);
const IndexOfManageRole = lazy(() =>
  import("../roles/platform-admin/manage-roles/IndexOfManageRole")
);

const LAYOUT_TYPE = {
  SIDE_BAR_NAV_BAR_LAYOUT: "SIDE_BAR_NAV_BAR_LAYOUT",
  LOGO_HEADER_LAYOUT: "LOGO_HEADER_LAYOUT",
};

const roles = {
  PFA: "Platform_Admin",
  PA: "Project_Admin",
  FL: "FL_Engineer",
  CM: "Client_Manager",
  ML: "ML_Engineer",
  SM: "Site_Manager",
};
export const { PFA, PA, FL, ML, SM, CM } = roles;
export const preDefinedRolesJsonList = [
  {
    title: "Platform Admin",
    role: PFA,
    path: "/fl-project",
    img: LOCAL_IMAGE.PFA_IMG,
  },
  {
    title: "Project Admin",
    role: PA,
    path: "/fl-project",
    img: LOCAL_IMAGE.PA_IMG,
  },

  {
    title: "Federated Learning Engineer",
    role: FL,
    path: "/fl-project",
    img: LOCAL_IMAGE.FL_IMG,
  },
  {
    title: "Machine Learning Engineer",
    role: ML,
    path: "/fl-project",
    img: LOCAL_IMAGE.ML_IMG,
  },
  {
    title: "Client Manager",
    role: CM,
    path: "/fl-project",
    img: LOCAL_IMAGE.CM_IMG,
  },
  {
    title: "Site Manager",
    path: "/fl-project",
    role: SM,
    img: LOCAL_IMAGE.SITE_MANAGER_IMG,
  },
];
const PRIVATE_ROUTES = [
  {
    path: "/eda-data",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <IndexOfEda />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
  {
    path: "/manage-clients",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <IndexOfManageClient />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM],
  },
  {
    path: "/user-management",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: `<IndexOfUserManage />`,
    loadingFallback: null,
    accessTo: [PFA, FL],
  },
  {
    path: "/dashboard",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: `<IndexOfDashboard />`,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
  {
    path: "/upload-data",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <UploadDataForm />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },

  // ------------Platform Routes Start----------
  {
    path: "/fl-project",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <ListFLProjects />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
  {
    path: "/create-fl-project",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <FLProjectCreation />,
    loadingFallback: null,
    accessTo: [PA],
  },
  {
    path: "/create-ml-project",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <MlTabs />,
    loadingFallback: null,
    accessTo: [PA],
  },
  {
    path: "/preview-fl-project/:id",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <FLProjectCreation />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
  {
    path: "/ml-project",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <IndexOfML />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
  {
    path: "/manage-role",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <IndexOfManageRole />,
    loadingFallback: null,
    accessTo: [PFA],
  },
  // --------------Platform Routes End----------
  // {
  //   path: "/settings",
  //   layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
  //   component: `<IndexOfUserSetting />`,
  //   loadingFallback: null,
  //   accessTo: [PFA, PA, FL, ML, SM],
  // },
  // {
  //   path: "/chatbot-history",
  //   layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
  //   component: `<IndexOfHistory />`,
  //   loadingFallback: null,
  //   accessTo: [PFA, PA, FL, ML, SM],
  // },
  {
    path: "/profile",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <IndexOfProfile />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
  {
    path: "/activity-log",
    layoutType: LAYOUT_TYPE.SIDE_BAR_NAV_BAR_LAYOUT,
    component: <IndexOfNotification />,
    loadingFallback: null,
    accessTo: [PFA, PA, FL, ML, SM, CM],
  },
];
const PUBLIC_ROUTES = [
  {
    path: "*",
    layoutType: null,
    component: <NotFound />,
    loadingFallback: null,
  },
  {
    path: "/",
    layoutType: null,
    component: <IndexOfLogin />,
    loadingFallback: null,
  },
  {
    path: "/ChunkTest",
    layoutType: null,
    component: <ChunkTest />,
    loadingFallback: null,
  },
  {
    path: "/sign-in",
    layoutType: null,
    component: <IndexOfLogin />,
    loadingFallback: null,
  },
  {
    path: "/role-selection",
    layoutType: LAYOUT_TYPE.LOGO_HEADER_LAYOUT,
    component: <RoleSelection />,
    loadingFallback: null,
  },
];
export { LAYOUT_TYPE, PRIVATE_ROUTES, PUBLIC_ROUTES };
